import { render } from "./kullaniciForm.vue?vue&type=template&id=20e61cfd"
import script from "./kullaniciForm.vue?vue&type=script&lang=js"
export * from "./kullaniciForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__